import { customAlphabet } from "nanoid"

const querySelectorSafeAlphabet = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
export const querySelectorSafeId = customAlphabet(querySelectorSafeAlphabet, 10)
